import { Config } from 'config/envConfig';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { alert, AlertType } from '@quyva/shared-ui';
import { PoweredByInfo } from './powereByComponent';
import { useAuth } from '../context/AuthContext';
import { getUrl } from './pdfDisplay/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEnvelope,
    faEnvelopeCircleCheck,
    faMailReply,
    faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { Features, isFeatureEnabled, OtherFeatures } from '@quyva/common';
import { Brand } from './brand';
import { useFeatureFlags } from '../context';
// import { handleLogout } from './userDetailAndAction';

const VerifyEmailBlockerPage = () => {
    const { featureFlagsData } = useFeatureFlags();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const { login, logout } = useAuth();
    const user = JSON.parse(localStorage.getItem('current'));
    const sendVerificationEmail = async () => {
        try {
            setLoading(true);
            const dynamicUrl = getUrl(
                `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/send_mail?email=${user.email}`
            );
            const authToken = encodeURIComponent(user.token); // Replace with your actual authentication token
            const headers = {
                Authorization: authToken,
                'Content-Type': 'application/json',
            };
            const response = await fetch(dynamicUrl, {
                method: 'GET',
                headers: headers,
            });
            if (response.ok) {
                const data = await response.json();
                // console.log(data);
                setLoading(false);
                setEmailSent(true);
            } else {
                setLoading(false);
                setEmailSent(false);
                alert(AlertType.ERROR, 'Failed to send verification mail');
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            setEmailSent(false);
            alert(
                AlertType.ERROR,
                'An error occurred while sending the verification mail'
            );
        }
    };
    useEffect(() => {
        if (emailSent) {
            setTimeout(() => {
                alert(AlertType.SUCCESS, 'Verification mail sent successfully');
                setEmailSent(false);
            }, 5);
        }
    }, [emailSent]);
    return (
        <div className='flex items-center justify-center min-h-screen bg-gradient-primary'>
            <div className='w-full md:w-1/2 max-w-[500px] flex-col border bg-backgrounds-white p-6 shadow-lg rounded-xl'>
                <div className='mb-8 w-full lg:w-3/5 mx-auto'>
                    {isFeatureEnabled(
                        [Features.OTHERS, OtherFeatures.LOGO],
                        featureFlagsData
                    ) && <Brand iconClassName={'w-20 h-20 mr-3'} />}
                </div>
                <div className='text-center'>
                    <h2 className='font-semibold text-xl text-texts-secondary300'>
                        <FontAwesomeIcon
                            icon={faEnvelopeCircleCheck}
                            className='mr-2'
                        />
                        Email Verification
                    </h2>
                    <p className='pt-5 text-texts-tertiary400 font-semibold'>
                        {user.email}
                    </p>
                    <p className='text-sm mr-10 ml-10 mb-10 mt-3 text-texts-secondary300'>
                        We’ve sent you a confirmation email on your email
                        address. Please click on link in that email to verify
                        your account.
                    </p>
                </div>
                <div className='flex flex-col text-sm w-full'>
                    {/* Resend Email button */}
                    <button
                        className='w-full font-semibold items-center justify-center text-texts-primary bg-buttons-primary border border shadow-inner hover:bg-gradient-buttons hover:border-buttons-primary hover:text-texts-primary p-3 rounded-lg'
                        type='submit'
                        onClick={sendVerificationEmail}
                    >
                        <span className='drop-shadow-sm'>
                            <FontAwesomeIcon
                                icon={loading ? faSpinner : faEnvelope}
                                className={
                                    loading ? 'animate-spin mr-1.5' : 'mr-1.5'
                                }
                            />
                            {loading ? 'Sending Email' : 'Resend Email'}
                        </span>
                    </button>

                    {/* Logout button */}
                    <button
                        className='mt-4'
                        onClick={() => {
                            // handleLogout(navigate);
                            logout();
                        }}
                    >
                        <span className='text-texts-tertiary font-semibold hover:text-texts-tertiary400'>
                            <FontAwesomeIcon
                                icon={faMailReply}
                                className='mr-1.5'
                            />
                            Back to Login
                        </span>
                    </button>
                </div>
                {/* Powered By Info */}
                <div className='w-full flex justify-center items-center mt-8'>
                    <PoweredByInfo />
                </div>
            </div>
        </div>
    );
};

export default VerifyEmailBlockerPage;
